import { PatternFormat } from "react-number-format";
import { TextField } from "@mui/material";

function FormatPhone({ label, value, onChange }) {
  return (
    <PatternFormat
      format="03## #######"
      label={label}
      variant="outlined"
      allowEmptyFormatting
      customInput={TextField}
      style={{ marginBottom: 5, marginTop: 8, width: "100%" }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export default FormatPhone;
